<template>
  <div>
    <signifi-call-preview
      @on-close-clicked="onPreviewClosed()"
      :signifiResponse="previewItem"
      v-if="showPreview"
    ></signifi-call-preview>
    <h3
      style="text-transform: uppercase; margin-bottom: 12px; margin-top: 20px;"
    >
      Signifi Calls
      <span v-if="!isTradingTerms" style="font-style: italic; color: #fc9a0f; font-size: 14px; text-transform: none; font-weight: normal;"><br/>This campaign cannot be manually rebooked because it's using the credit card payment option.</span>
    </h3>
    <div
      style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px;"
    >
      <form @submit.prevent="handleSignifiCall('product')">
        <p class="label">
          Product call
        </p>
        <p class="value">
          {{ signifiProductResponse || 'N/A' }}
        </p>
        <div
          style="display: flex;align-items: center;justify-content: flex-end; margin-top: 8px; cursor: pointer;"
          @click="handleView(signifiProductResponse)"
          v-if="signifiProductResponse"
        >
          <p class="mb-0" style="font-size: 12px; color: #13a3eb;">View</p>
          <div
            style="height: 16px; width: 16px; display: flex; align-items: center; justify-content: center;"
          >
            <arrow-right color="#13a3eb"></arrow-right>
          </div>
        </div>
        <div class="mt-3" v-if="!signifiProductResponse && updatable">
          <div class="form-group mb-3">
            <input
              type="text"
              name="signifi-product-note"
              id="signifi-product-note"
              class="form-control"
              v-model="productNote"
              required
            />
            <label
              style="letter-spacing: 0px; font-size: 12px;"
              for="signifi-product-note"
              ><span style="color: red;">*&nbsp;</span>Note:</label
            >
          </div>
        </div>
        <button
          class="btn btn-primary mb-2"
          :disabled="!productNote || signifiProductResponse"
          type="submit"
          style="padding: 0px 10px;height: 35px;border-radius: 0px;transform: translateY(-3px);"
          v-if="updatable"
        >
          Create Product
        </button>
      </form>
      <form @submit.prevent="handleSignifiCall('order')">
        <p class="label">
          Order call
        </p>
        <p class="value">
          {{ signifiOrderResponse || 'N/A' }}
        </p>
        <div
          style="display: flex;align-items: center;justify-content: flex-end; margin-top: 8px; cursor: pointer;"
          @click="handleView(signifiOrderResponse)"
          v-if="signifiOrderResponse"
        >
          <p class="mb-0" style="font-size: 12px; color: #13a3eb;">View</p>
          <div
            style="height: 16px; width: 16px; display: flex; align-items: center; justify-content: center;"
          >
            <arrow-right color="#13a3eb"></arrow-right>
          </div>
        </div>
        <div class="mt-3" v-if="!signifiOrderResponse && updatable">
          <div class="form-group mb-3">
            <input
              type="text"
              name="signifi-product-note"
              id="signifi-product-note"
              class="form-control"
              v-model="orderNote"
              required
            />
            <label
              style="letter-spacing: 0px; font-size: 12px;"
              for="signifi-product-note"
              ><span style="color: red;">*&nbsp;</span>Note:</label
            >
          </div>
        </div>
        <button
          class="btn btn-primary mb-2"
          :disabled="
            !orderNote || signifiOrderResponse || !signifiProductResponse
          "
          type="submit"
          style="padding: 0px 10px;height: 35px;border-radius: 0px;transform: translateY(-3px);"
          v-if="updatable"
        >
          Place Order
        </button>
        <p
          style="letter-spacing: 0px; font-size: 12px; margin: 0px;"
          v-if="updatable"
        >
          <em>(Needs product call before order can be placed)</em>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import ArrowRight from '../../assets/icons/arrow-right.vue';
import CampaignServices from '../../services/campaigns';
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';
import SignifiCallPreview from './SignifiCallPreview.vue';
export default {
  data() {
    return {
      showPreview: false,
      previewItem: null,
      productNote: null,
      orderNote: null,
      paymentMethod: null,
    };
  },
  props: ['id', 'signifiProductResponse', 'signifiOrderResponse', 'status'],
  components: {
    SignifiCallPreview,
    ArrowRight,
  },
  computed: {
    updatable() {
      return !this.status && this.isTradingTerms ? true : false;
    },
    isTradingTerms() {
      return this.paymentMethod === "trading-terms"
    },
  },
  methods: {
    handleView(preview) {
      this.previewItem = preview;
      this.showPreview = true;
    },
    onPreviewClosed() {
      this.showPreview = false;
      this.previewItem = null;
    },
    async getPaymentMethod() {
      const response = await CampaignServiceV2.getCampaignPaymentMethod(
        this.id
      );
      if (
        response.data &&
        response.data.data &&
        response.data.data.paymentMethod
      ) {
        this.paymentMethod = response.data.data.paymentMethod;
      }
    },
    async handleSignifiCall(type) {
      try {
        await CampaignServices.manuallyCallSignifi(this.id, type);
        this.$swal({
          type: 'error',
          title: 'Success!',
          text: `Signifi ${type} call updated successfully!`,
        });
        await CampaignServiceV2.logSignifiCall(this.id, {
          note: type === 'order' ? this.orderNote : this.productNote,
          type,
        });
        this.$emit('on-signifi-called');
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'Error',
          text: `Failed to update Signifi ${type} call.`,
        });
      } finally {
        this.note = null;
      }
    },
  },
  mounted() {
    this.getPaymentMethod();
  },
};
</script>

<style scoped>
.label {
  text-transform: uppercase;
  margin-bottom: 0px;
  font-size: 12px;
}
.value {
  color: black;
  margin-bottom: 0px;
  max-height: 4.2em;
  overflow: hidden;
  word-wrap: break-word;
  text-overflow: ellipsis;
}
</style>
